import { render, staticRenderFns } from "./StatementOfAccounts.vue?vue&type=template&id=0d1fcf2a"
import script from "./StatementOfAccounts.vue?vue&type=script&lang=js"
export * from "./StatementOfAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports